
// Track Promotions menu click
document.addEventListener("click", function (e) {
  const menuItem = e.target.closest(".header__menu-item.promotions a");
  if (!menuItem) return;

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("custom_event", {
      name: "promotions_viewed",
      source: "header_menu",
      label: "Promotions",
      page_url: window.location.href
    });
  }
}, true);


// Track Claim Gift button clicks
document.addEventListener("click", function (e) {
  const claimBtn = e.target.closest(".product-card__cta-link.claim-gift");
  if (!claimBtn) return;

  const tile = claimBtn.closest(".collection-listing__item");
  if (!tile) return;

  const tileName =
    tile.querySelector(".product-card__title")?.textContent?.trim() || "";

  const promotionCollection =
    tile.querySelector(".product-card__vendor")?.textContent?.trim() || "";

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("custom_event", {
      name: "claim_gift_clicked",
      tile_name: tileName,
      promotion_collection: promotionCollection,
      destination_url: claimBtn.getAttribute("href")
    });
  }
}, true);


// Track Explore Bestsellers button click on empty cart
document.addEventListener("click", function (e) {
  const exploreBtn = e.target.closest(".cartx-empty-upsell-btn");
  if (!exploreBtn) return;

  const pageTitle = document.querySelector("main h1")?.textContent?.trim() ||document.title|| "";

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("custom_event", {
      name: "Explorebestsellers_clicked",
      page_title: pageTitle
    });
  }
}, true);




// Track Apply Discount Card button click
(function () {
  const _originalShowMessage = window.showMessage;
  let pendingDiscountCode = null;

  window.showMessage = function (message, isError) {
    _originalShowMessage(message, isError);

    if (!pendingDiscountCode) return;

    const isIntermediate =
      message === "Applying discount..." ||
      message === "Removing discount..." ||
      message === "Applying discount";

    if (isIntermediate) return;

    const code = pendingDiscountCode;
    pendingDiscountCode = null;

    const isSuccessful = !isError;

    if (window.Shopify?.analytics?.publish) {
      Shopify.analytics.publish("custom_event", {
        name: "Applydiscountcard_clicked",
        Discount_applied: isSuccessful ? "Successful" : "Unsuccessful",
        Discount_name: code,
        Discountunsuccessful_message: isSuccessful
          ? "Discount successfully applied"
          : message
      });
    }
  };

  document.addEventListener("click", function (e) {
    const applyBtn = e.target.closest("#cartx-apply-code-button, .prv-submit-button");
    if (!applyBtn) return;

    const discountInput = document.querySelector("#cartx-discount-code, .prv-coupon-input");
    const code = discountInput?.value?.trim() || "";
    if (code) pendingDiscountCode = code;
  }, true);

  document.addEventListener("keypress", function (e) {
    if (e.key !== "Enter") return;
    const input = e.target.closest("#cartx-discount-code, .prv-coupon-input");
    if (!input) return;
    const code = input.value?.trim() || "";
    if (code) pendingDiscountCode = code;
  }, true);

})();

// Track GWP_added when a free gift item appears in the cart drawer
(function () {
  const trackedGifts = new Set(); // Prevent duplicate events

  const observer = new MutationObserver(function () {
    document.querySelectorAll(".cartx-drawer-product-item.cartx-free-gift-item").forEach(function (giftItem) {
      const variantId = giftItem.getAttribute("data-variant-id");
      if (!variantId || trackedGifts.has(variantId)) return;

      const gwpName = giftItem.querySelector("[class*='title'], [class*='product-title']")
        ?.textContent?.trim() || "";

      // Match to metaobject rule for offer name
      let gwpOfferName = "";
      try {
        const metaobject = JSON.parse(document.body.getAttribute("metaobject") || "[]");
        const matchingRule = metaobject.find(rule =>
          rule.get_y?.some(v => v.split("/").pop() === String(variantId))
        );
        gwpOfferName = matchingRule?.progress_bar_message || matchingRule?.title || "";
      } catch (e) {}

      trackedGifts.add(variantId);

      if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish("custom_event", {
          name: "GWP_added",
          GWP_name: gwpName,
          GWP_offername: gwpOfferName
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


// Track You Might Also Like - Add to Bag
document.addEventListener("click", function (e) {
  const addBtn = e.target.closest(".cartx-upsell-product-item .cartx-add-to-cart");
  if (!addBtn) return;

  const upsellItem = addBtn.closest(".cartx-upsell-product-item");
  if (!upsellItem) return;

  const productName = upsellItem.querySelector(
    "[class*='title'], [class*='name'], [class*='upsell-item-title']"
  )?.textContent?.trim() || "";

  const cartProductList = user_cart?.items?.map(item => item.title) || [];

  const cartTotal = ((user_cart?.total_price || 0) / 100).toFixed(2);

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("custom_event", {
      name: "Youmightalsolike_addedtobag",
      Youmightalsolike_productname: productName,
      Cartitem_productlist: cartProductList,
      Cart_total: cartTotal
    });
  }
}, true);


// Track Checkout button click
document.addEventListener("click", function (e) {
  const checkoutBtn = e.target.closest(".cartx-checkout-button");
  if (!checkoutBtn) return;

  // Try global user_cart first, fallback to cart API
  const cart = window.user_cart;

  function publishEvent(cartData) {
    const cartProductList = cartData?.items?.map(item => item.title) || [];

    if (window.Shopify?.analytics?.publish) {
      Shopify.analytics.publish("custom_event", {
        name: "Checkout_clicked",
        Cartitem_productlist: cartProductList
      });
    }
  }

  if (cart?.items) {
    publishEvent(cart);
  } else {
    // Fallback: fetch live cart
    fetch("/cart.js")
      .then(res => res.json())
      .then(cartData => publishEvent(cartData))
      .catch(err => console.error("Cart fetch failed:", err));
  }
}, true);

document.querySelectorAll("[class*='checkout']").forEach(el => {
  console.log(el.className, el.tagName);
});


// Track Dynamic Tile (PLP promotion banner) clicks
document.addEventListener("click", function (e) {
  const tileLink = e.target.closest(".collection-listing__item-promotion-banner-link");
  if (!tileLink) return;

  const tile = tileLink.closest(".collection-listing__item--promotion-banner");
  if (!tile) return;

  const getImageName = (img) => {
    const src = img?.currentSrc || img?.getAttribute("src") || "";
    if (!src) return "";
    return src.split("?")[0].split("/").pop() || "";
  };

  const desktopImg = tile.querySelector(".collection-listing__item-promotion-banner-image--desktop");
  const mobileImg = tile.querySelector(".collection-listing__item-promotion-banner-image--mobile");

  const isMobile = window.matchMedia("(max-width: 900px)").matches;

  const payload = {
    name: "Dynamictile_clicked",
    Collection_name: tile.dataset.collectionName || "",
    Display_name: tile.dataset.displayName || "",
    tile_link: tileLink.getAttribute("href") || null
  };

  if (isMobile) {
    payload.Mobile_image_name = getImageName(mobileImg) || getImageName(desktopImg);
  } else {
    payload.Desktop_image_name = getImageName(desktopImg) || getImageName(mobileImg);
  }

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("custom_event", payload);
  }
}, true);


// Track sub-collection pill clicks (Shop Now, Brands, About Us, Blogs)
document.addEventListener("click", function (e) {
  const pillLink = e.target.closest(".collection-listing__feat-collections-item-link");
  if (!pillLink) return;

  const subcollectionName =
    pillLink.querySelector(".collection-listing__feat-collections-item-label")?.textContent?.trim() ||
    pillLink.textContent?.trim() ||
    "";

  const nav = pillLink.closest("feat-collections-nav");
  const residingPage =
    nav?.dataset.subcollectionPage ||
    document.querySelector("main h1")?.textContent?.trim() ||
    document.title ||
    "";

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("custom_event", {
      name: "subcollection_clicked",
      Subcollection_name: subcollectionName,
      Subcollection_residing_page: residingPage
    });
  }
}, true);


// Track hamburger (main menu) opens
document.addEventListener("click", function (e) {
  const menuTrigger = e.target.closest("[header-mob-menu-trigger]");
  if (!menuTrigger) return;

  // The same button also closes the menu. This capture listener runs before the
  // header's toggle handler, so a closed state here means this click opens it.
  if (menuTrigger.getAttribute("aria-expanded") === "true") return;

  let device = "Desktop";
  if (window.matchMedia("(max-width: 767px)").matches) {
    device = "Mobile";
  } else if (window.matchMedia("(max-width: 1024px)").matches) {
    device = "Tablet";
  }

  if (window.Shopify?.analytics?.publish) {
    Shopify.analytics.publish("custom_event", {
      name: "Mainmenu_clicked",
      Current_page: window.location.pathname,
      Device: device
    });
  }
}, true);

